import { render, staticRenderFns } from "./editJournal.vue?vue&type=template&id=61b57e84&scoped=true"
import script from "./editJournal.vue?vue&type=script&lang=js"
export * from "./editJournal.vue?vue&type=script&lang=js"
import style0 from "./editJournal.vue?vue&type=style&index=0&id=61b57e84&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61b57e84",
  null
  
)

export default component.exports